import { useRouter } from 'next/router';
import React from 'react';
import { ModalMainInterface } from 'src/features/common/modal/modal.types';
import {
    StyledBottomTextsWrapper,
    StyledModal,
    StyledText,
    StyledTopTextsWrapper,
} from 'src/features/white-labels/thesportmuseum/app/modals/disclaimer-modal/disclaimer-modal.styles';
import { Button } from 'src/ui/common/atoms/button';
import { ModalBody, ModalFooterActions, ModalHeader } from 'src/ui/common/layouts/modal';
import { writeToLocalStorage } from 'src/utils/local-storage.utils';

const DISCLAIMER = 'disclaimer';
export const DisclaimerModalComponent: React.VFC<ModalMainInterface> = ({ closeModal }) => {
    const { push } = useRouter();
    const agreeHandler = () => {
        writeToLocalStorage(DISCLAIMER, 'true');
        closeModal?.();
    };

    const declineHandler = async () => {
        await push('https://spaceseven.com/marketplace');
    };

    return (
        <>
            {/* eslint-disable-next-line react/no-unknown-property */}
            <style jsx global>
                {`
                    #overlay {
                        transition: backdrop-filter 0.2s;
                        backdrop-filter: blur(10px) opacity(1);
                    }
                `}
            </style>
            <StyledModal>
                <ModalHeader>DISCLAIMER</ModalHeader>
                <ModalBody>
                    <StyledTopTextsWrapper>
                        <StyledText>
                            The information and documents provided here in are for informational purposes only and do
                            not constitute an offer, solicitation with respect to financial instruments, a
                            recommendation or investment advice to buy or sell or hold the securities offered, nor shall
                            they or any part thereof form the basis of any contract or commitment whatsoever.
                        </StyledText>
                        <StyledText>
                            Any product, investment, transaction referred to in such information and documents may be
                            unsuitable for the investor to whom they are addressed. The recipients of such information
                            and documents are solely responsible for independently evaluating and reviewing the
                            products, investments and transactions referred to here in.
                        </StyledText>
                        <StyledText>
                            Investors must make their own assessment of the suitability of the securities referred to
                            herein based on the merits and risks involved, their own investment strategy and their
                            legal, tax and financial position. The investor may not copy, modify, publish and forward
                            this information and documents.
                        </StyledText>
                        <StyledText>
                            The above information and documents do not constitute or form part of any offer or
                            solicitation of any offer in any jurisdiction other than Austria (the "Other
                            Jurisdictions").{' '}
                        </StyledText>
                        <StyledText>
                            The securities described on the website have not been and will not be registered under the
                            U.S. Securities Act of 1933, as amended, or under the corresponding rules applicable in the
                            Other Jurisdictions. Access to the information available on the website, the Information
                            Sheet pursuant to the Austrian Alternative Financing Act (Alternativfinanzierungsgesetz) and
                            the other documents published on the website may be restricted by laws and regulations
                            governing securities in certain jurisdictions.
                        </StyledText>
                        <StyledText>
                            Therefore, such access is only permitted to persons who are neither residents nor domiciled
                            in the Other Jurisdictions and who are not U.S. persons as defined in Regulation S under the
                            United States Securities Act of 1933, as amended, nor acting on their behalf or for their
                            benefit.
                        </StyledText>
                        <StyledText>
                            Only persons falling under the category described above are entitled to access the
                            information and documents published on this website. Granting access and downloading the
                            above information is excluded for persons other than those mentioned above.
                        </StyledText>
                        <StyledText>
                            THE CR SPORTS CONSULTING GMBH is not liable for the user's independent decisions and actions
                            based on the information and documents published on this website.
                        </StyledText>
                    </StyledTopTextsWrapper>
                    <StyledBottomTextsWrapper>
                        <StyledText isTextWhite>
                            By clicking "Continue", I declare that I am not currently resident in the Other
                            Jurisdictions, in particular not in the United States of America, Australia, Japan or
                            Canada, and that I am not acting on behalf of or for the benefit of US persons as defined in
                            Regulation S of the United States Securities Act of 1933, as amended.{' '}
                        </StyledText>
                        <StyledText isTextWhite>
                            By clicking "Continue", I declare that I have read and understood the above restrictions in
                            full, that I will abide by them and that I undertake not to transfer the information and
                            documents published on this website to the Other Jurisdictions.
                        </StyledText>
                    </StyledBottomTextsWrapper>
                </ModalBody>
                <ModalFooterActions>
                    <Button variant="white" onClick={declineHandler}>
                        Decline
                    </Button>
                    <Button variant="gradient" onClick={agreeHandler}>
                        Continue
                    </Button>
                </ModalFooterActions>
            </StyledModal>
        </>
    );
};